export default function Pagination() {
  return (
    <div className="flex gap-1 justify-center mt-10">
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        &laquo;
      </a>
      <a
        href="#"
        className="text-white bg-red-500 py-1 md:px-4 px-3 md:text-base text-sm rounded"
      >
        1
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        2
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        3
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        4
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        5
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        6
      </a>
      <a
        href="#"
        className="text-black dark:text-white py-1 md:px-4 px-3 md:text-base text-sm rounded hover:text-white hover:bg-red-400"
      >
        &raquo;
      </a>
    </div>
  );
}
